<img src="assets/images/gif/loader.gif" alt="Billion" width="100" height="100">